import { Container, Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useMount } from 'react-use';
import ReactMarkdown from 'react-markdown';
import { makeStyles } from '@mui/styles';
import { TERMS_LIST } from '../common/consts';
import { termsGetData } from '../common/util';

const useStyles = makeStyles((theme) => ({
  markDownGrid: {
    '& div': {
      overflowY: 'scroll',
      fontSize: '.7rem',
      border: `1px solid ${theme.palette.text.primary}`,
      padding: '4px 10px',
      height: '25vh',
      margin: `${theme.spacing(2)} 0`,
      opacity: 0.5,
    },
  },
}));

const TermPage = () => {
  const classes = useStyles();
  const [terms, setTerms] = useState([]);

  useMount(async () => {
    const termsArr = await termsGetData();
    setTerms([...termsArr]);
  });

  return (
    <Container maxWidth="lg">
      <Grid container spacing={2} sx={{ padding: 2 }}>
        <Grid item xs={12}>
          <Typography variant="h4">Pibo Manager Console 약관</Typography>
        </Grid>
        {TERMS_LIST.map(({ label }, i) => (
          <Grid item xs={12} className={classes.markDownGrid}>
            <Typography variant="h5" gutterBottom>
              {label}
            </Typography>
            <div>
              <ReactMarkdown>{terms[i]}</ReactMarkdown>
            </div>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default TermPage;
